<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSecurityGroupListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../security_group/TableExpand.vue";
var tableSecurityGroupVue = {};
export default {
  name: "TableSecurityGroup",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.SecurityGroup.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.SecurityGroup.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.SecurityGroup.securityGroupName"),
          key: "groupName"
        },
        {
          title: this.$t("RAM.AWS.SecurityGroup.securityGroupID"),
          key: "groupId"
        },
        {
          title: "direction",
          key: "direction"
        }
      ],
      tableSecurityGroupListData: []
    };
  },
  beforeCreate: function() {
    tableSecurityGroupVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("groupIdSearchID", function(val) {
      tableSecurityGroupVue.groupId = val;
    });
    eventBus.$on("companyId", function(val) {
      tableSecurityGroupVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 分页显示数据
    /****************************************************/
    getSecurityGroupListData: function() {
      var pageSecurityGroupDate = {
        pageNum: this.current,
        pageSize: this.pageSize,
        groupId: tableSecurityGroupVue.groupId,
        companyId: tableSecurityGroupVue.companyId
      };

      //安全组ID
      if (
        this.$route.query.type == "groupId" &&
        pageSecurityGroupDate.groupId == ""
      ) {
        pageSecurityGroupDate.groupId = this.$route.query.groupIds;
      }

      this.$api.resourceManagement
        .selectAWSSecurityGroup(pageSecurityGroupDate)
        .then(res => {
          this.tableSecurityGroupListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 销毁caseSearchID
    beforeDestroy: function() {
      eventBus.$off("groupIdSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/security_group/TableSecurityGroup.vue